import { createAsyncActionType } from './index';

export const BOOKMARK_COURSES_GET = createAsyncActionType(
  'bookmarks',
  'BOOKMARK_COURSES_GET'
);

export const BOOKMARK_MODULES_GET = createAsyncActionType(
  'bookmarks',
  'BOOKMARK_MODULES_GET'
);

export const BOOKMARK_EVENTS_GET = createAsyncActionType(
  'bookmarks',
  'BOOKMARK_EVENTS_GET'
);

export const BOOKMARK_DOCUMENTS_GET = createAsyncActionType(
  'bookmarks',
  'BOOKMARK_DOCUMENTS_GET'
);

export const BOOKMARK_SET = createAsyncActionType('bookmarks', 'BOOKMARK_SET');
